import Marquee from "react-fast-marquee";
import { MARQUEE } from "@/data/content";

export const MarqueeBand = () => (
  <section className="relative border-y border-white/10 bg-[#0A0A0A] py-8" data-testid="marquee">
    <Marquee speed={40} gradient gradientColor="#0A0A0A" gradientWidth={120} autoFill>
      {MARQUEE.map((item, i) => (
        <div key={i} className="flex items-center">
          <span className="font-display text-4xl uppercase tracking-tight text-transparent md:text-6xl" style={{ WebkitTextStroke: "1px rgba(243,244,246,0.28)" }}>
            {item}
          </span>
          <span className="mx-8 text-[#D4F870] md:mx-12">◆</span>
        </div>
      ))}
    </Marquee>
  </section>
);
